import { render, staticRenderFns } from "./device-list.vue?vue&type=template&id=c71a2876"
import script from "./device-list.vue?vue&type=script&lang=js"
export * from "./device-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c71a2876')) {
      api.createRecord('c71a2876', component.options)
    } else {
      api.reload('c71a2876', component.options)
    }
    module.hot.accept("./device-list.vue?vue&type=template&id=c71a2876", function () {
      api.rerender('c71a2876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/group/device-list.vue"
export default component.exports